/**
 * @generated SignedSource<<5506dcd51f1f3474289a7939a2933483>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberSchedule_Bookings$data = {
  readonly bookings: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly eventRegistrations?: {
          readonly count: number;
        } | null | undefined;
        readonly id: string;
        readonly startSlot: {
          readonly agenda: {
            readonly date: string;
            readonly timeSlots: {
              readonly firstDateTime: string | null | undefined;
            } | null | undefined;
          };
          readonly dateTime?: string | null | undefined;
          readonly time?: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"BookingCard_Booking">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly club: {
    readonly departments: {
      readonly count: number;
    } | null | undefined;
  };
  readonly id: string;
  readonly managedBookings: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly eventRegistrations?: {
          readonly count: number;
        } | null | undefined;
        readonly id: string;
        readonly startSlot: {
          readonly agenda: {
            readonly date: string;
            readonly timeSlots: {
              readonly firstDateTime: string | null | undefined;
            } | null | undefined;
          };
          readonly dateTime?: string | null | undefined;
          readonly time?: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"BookingCard_Booking">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "MemberSchedule_Bookings";
};
export type MemberSchedule_Bookings$key = {
  readonly " $data"?: MemberSchedule_Bookings$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberSchedule_Bookings">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Variable",
    "name": "dateTimeGte",
    "variableName": "dateTimeGTE"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "DATE_TIME"
    }
  }
],
v4 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BookingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRegistrationConnection",
                "kind": "LinkedField",
                "name": "eventRegistrations",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "type": "StandardBooking",
            "abstractKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "startSlot",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotConnection",
                    "kind": "LinkedField",
                    "name": "timeSlots",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstDateTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "time",
                    "storageKey": null
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingCard_Booking"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "dateTimeGTE"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberSchedule_Bookings",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DepartmentConnection",
          "kind": "LinkedField",
          "name": "departments",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v3/*: any*/),
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "bookings",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v3/*: any*/),
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "managedBookings",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Member",
  "abstractKey": null
};
})();

(node as any).hash = "8d4f7ee89c11e7386f8ee4ad4ada8b0b";

export default node;
